import { Button, Col, Form, Modal, Row } from "antd";
import React, { useMemo } from "react";
import localStorageContent from "../../../utils/localstorage";
import { formLayout } from "../../../utils";
import GenerateElements from "../../../components/GenerateElements";
import { gutterBlobal } from "../Lead/constants";

function BackToAssign({
  submitBackStep,
  setCurrentBackStepDep,
  showBackStepModal,
  setBackStepModal,
  onChangeSubmitBack,
}: any) {
  const userData = localStorageContent.getUserData();
  const [form] = Form.useForm();

  const depts = [
    { label: "Process", value: 2 },
    { label: "Preparation", value: 3 },
    { label: "Review", value: 4 },
    { label: "Finance", value: 5 },
    { label: "Submission", value: 6 },
  ];

  const endRange = depts.findIndex(
    (item) => item.value === userData?.departmentId,
  );

  const fieldsData = [
    {
      label: "Department",
      key: "deptId",
      elementType: "SELECT",
      required: true,
      disable: false,
      options: depts.slice(0, endRange),
      onChangeField: onChangeSubmitBack,
      type: "text",
      placeholder: "Select Department",
      config: {
        rules: [{ required: true, message: "Please Select Department" }],
      },
    },
    {
      label: "Comment",
      key: "comment",
      elementType: "INPUT",
      onChangeField: onChangeSubmitBack,
      required: true,
      disable: false,
      type: "text",
      placeholder: "Enter Comment",
      config: {
        rules: [{ required: true, message: "Please Enter Comment" }],
      },
    },
  ];

  /**
   * Hide department field for Super Admin
   */
  const generateFormFields = useMemo(() => {
    let copyfields: any[] = [...fieldsData];

    if (userData?.role === "1") {
      copyfields = copyfields.filter((item) => item.key !== "deptId");
    }

    return copyfields;
  }, [userData]);

  /**
   * Handle form submit
   */
  const handleSubmit = (values: any) => {
    const payload = { ...values };

    // Super Admin → always send Submission department
    if (userData?.role === "1") {
      payload.deptId = 6;
    }

    submitBackStep(payload);
  };

  return (
    <>
      <Modal
        title={"Select Department"}
        open={showBackStepModal}
        onCancel={() => {
          setCurrentBackStepDep(null);
          setBackStepModal(false);
        }}
        footer={null}
        className="user-details__backstep-modal"
      >
        <Form
          {...formLayout}
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{ width: "100%" }}
        >
          <Row gutter={gutterBlobal}>
            {generateFormFields.map((formItem: any, index: number) => (
              <Col key={index} xl={24} sm={24} xs={24}>
                <GenerateElements elementData={formItem} />
              </Col>
            ))}
          </Row>

          <Row justify="end">
            <Col>
              <Form.Item>
                <Button onClick={() => setBackStepModal(false)}>Cancel</Button>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default BackToAssign;
